$(function($){
  
	// Header scroll
	$(window).scroll(function(e) {
		if ($(document).scrollTop() > 10) {
			$('.site-header').addClass('has-scrolled');
		}
		else {
			$('.site-header').removeClass('has-scrolled');
		}
	});
  
  	// Mobile menu
	$('.toggle-menu').on('click', function(e){
		e.preventDefault();
		$('.site-nav').toggleClass('active');
        $('.site-header:not(.has-scrolled)').toggleClass('has-scrolled');
		$(this).toggleClass('active');
	});
  
  	// Megamenu columns
    $('.site-nav__label').each(function() {
        $(this).nextUntil('.site-nav__label').addBack().wrapAll('<div class="col"></div>');
    });

    $('.site-nav--has-submenu').mouseenter(function() {
      $('.site-header').addClass('megamenu--open');
      
      var megamenu = $(this).children('.site-nav__submenu');
      var position = $(this).position();
      var posLeft = position.left - 45;
      
      megamenu.css('left', posLeft);
    });

    $('.site-nav--has-submenu').mouseleave (function() {
      $('.site-header').removeClass('megamenu--open');
    });
  
  

    //Less than 1024px
    if ($(window).width() < 992) {
       $('.site-nav ul > li.site-nav--has-submenu').append('<span class="arrow"></span>');
    }

    $(document).on('click', '.site-nav ul > li.site-nav--has-submenu > a', function(e){
      e.preventDefault();

      $(this).parent().toggleClass('is-open');
      $(this).next().slideToggle();
    });
  
    // Hide megamenu items if they are empty
    $('.megamenu-full').each(function(){
      $(this).filter(function() {
        var text = $(this).text().replace(/\s*/g, '');
        return !text;
      }).hide();
    });
  
    $('.megamenu-featured').each(function(){
      $(this).filter(function() {
        var text = $(this).text().replace(/\s*/g, '');
        return !text;
      }).hide();
    });
  
  
  
  	// Hero slider
    const heroSlider = new Swiper('.hero-slider', {
      slidesPerView: 1,
  	  spaceBetween: 0,
      speed: 1000,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      },
      navigation: {
        nextEl: '.hero-slider-next',
        prevEl: '.hero-slider-prev',
      }
    });
  
    // Ethos slider
    const ethosSlider = new Swiper('.ethos-slider', {
      slidesPerView: 1.3,
  	  spaceBetween: 30,
      speed: 500,
      centeredSlides: false,
      slidesOffsetBefore: 20,
      slidesOffsetAfter: 20,
      navigation: {
        nextEl: '.ethos-slider-next',
        prevEl: '.ethos-slider-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 2.3,
  	  	  spaceBetween: 30,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 30,
          centeredSlides: false,
        },
        992: {
          slidesPerView: 1.6,
  	  	  spaceBetween: 30,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 30,
          centeredSlides: false,
        },
        1300: {
          slidesPerView: 2.3,
  	  	  spaceBetween: 30,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 30,
          centeredSlides: false,
        }
      }
    });
  
    // Featured collection slider
    const featuredCollectionSlider = new Swiper('.featured-collection-slider', {
      slidesPerView: 1.3,
  	  spaceBetween: 30,
      speed: 500,
      loop: true,
      centeredSlides: true,
      navigation: {
        nextEl: '.featured-collection-slider-next',
        prevEl: '.featured-collection-slider-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 2,
  	  	  spaceBetween: 30,
          centeredSlides: true,
        },
        992: {
          slidesPerView: 2.3,
  	  	  spaceBetween: 30,
          centeredSlides: true,
        },
        1300: {
          slidesPerView: 3,
  	  	  spaceBetween: 30,
          centeredSlides: true,
        }
      }
    });
  
  
    // Product main slider
    const productMediaSlider = new Swiper('.product-media-slider', {
      slidesPerView: 1,
  	  spaceBetween: 0,
      speed: 500,
      loop: true,
      navigation: {
        nextEl: '.product-media-slider-next',
        prevEl: '.product-media-slider-prev',
      },
      breakpoints: {
        600: {
          slidesPerView: 1,
        },
        992: {
          slidesPerView: 2,
        }
      },
      on: {
        afterInit: function () {
          console.log('product swiper initialized');
        },
      }
    });
  
  	// Testimonials
    if ($('.section-testimonials').length){
      var quoteLength = $(".testimonial-block").length;
      function randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
      }

      const rndInt = randomIntFromInterval(1, quoteLength)

      $('.testimonial-block').each(function(){
        var $this = $(this);
        var id = $this.attr('data-id');

        if (id == rndInt) {
          $this.addClass('active');
        }
      });
    }
  
  
  
   const productRelatedSlider = new Swiper('.product-related-slider', {
    slidesPerView: 1.3,
    spaceBetween: 30,
    speed: 500,
    init: false,
    loop: true,
    centeredSlides: true,
    navigation: {
      nextEl: '.product-related-slider-next',
      prevEl: '.product-related-slider-prev',
    },
    breakpoints: {
      600: {
        slidesPerView: 2.3,
        spaceBetween: 30,
        centeredSlides: true,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
        centeredSlides: false,
      }
    }
  });
  
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.swiper-slide')) {
              this.classList.add('product-recommendations--loaded');
              productRelatedSlider.init();
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
  
});